import GenericDB from './generic-db';

export default class DevicesDB extends GenericDB {
  constructor() {
    super('devices');
  }

  // Here you can extend UserDB with custom methods
}
